
import Vue from 'vue'
import Component from 'vue-class-component'
import { Watch } from "vue-property-decorator"

@Component({})
export default class Snackbar extends Vue {
  private show = false

  get errorText () {
    this.show = this.$store.getters["error/error"] !== null
    return this.$store.getters["error/error"]
  }

  @Watch('show')
  disableToastTimer () {
    if (this.show) {
      setTimeout(() => {
        this.disableToast()
      }, 5000)
    }
  }

  private disableToast () {
    this.$store.dispatch("error/setError", null)
  }
}
